import { styled, Typography } from '@mui/material';

export const InnerContainer = styled('div')`
  border: ${({ theme }) => `1px solid ${theme.palette.primary.grey}`};
  border-radius: 8px;
  margin-top: 24px;
  @media (max-width: 1023px) {
    margin-top: 8px;
  }
`;

export const FlexW = styled('div')`
  background: ${({ theme }) => theme.palette.white.main};
  box-shadow: 0px 25px 12px -20px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  padding: 16px;
  cursor: pointer;
`;

export const DescriptionW = styled('div')``;

export const SectionTitle = styled(Typography)`
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  margin-bottom: 40px;

  @media (max-width: 1023px) {
    display: none;
  }
`;

export const SubTitle = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.p080};
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
`;

export const PreviewSection = styled('div')`
  margin-bottom: 8px;
  background-color: #fbfbfb;
  backdrop-filter: blur(20px);
  border-radius: 8px;
  min-height: 200px;
  margin-top: 40px;
  @media (max-width: 1023px) {
    margin-top: 0px;
    padding: 0px 11px 23px;
  }
`;

export const CompanyCardHeader = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
`;

export const CompanyIconBg = styled('div')`
  background-color: ${({ theme }) => theme.palette.info.main};
  border-radius: 8px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;

  & svg {
    width: 22px;
    height: 22px;
    fill: white;
    stroke: white;
  }
`;
